import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=4e14d294&scoped=true"
import script from "./registration.vue?vue&type=script&lang=ts"
export * from "./registration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e14d294",
  null
  
)

export default component.exports